import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';

export default class ImageCarousel {
  constructor(emblaNode) {
    this.root = emblaNode.parentNode;
    const {
      isSlideshow = 'false',
      slideshowDelay = '3',
      showMarkers = 'false',
    } = this.root.dataset;
    const options = {
      loop: true,
      align: 'start',
    };
    let plugins = [];
    if (isSlideshow === 'true') {
      plugins.push(Autoplay({ delay: Number(slideshowDelay) * 1000 }));
    }

    const emblaApi = EmblaCarousel(emblaNode, options, plugins);
    this.initButtons(emblaApi);
    if (showMarkers === 'true') {
      this.initMarkers(emblaApi);
    }
  }

  initMarkers(emblaApi) {
    const markersWrapper = this.root.nextElementSibling;
    const markers = [];
    if (
      !markersWrapper ||
      !markersWrapper.classList.contains('carousel--markers-wrapper')
    )
      return;

    emblaApi.scrollSnapList().forEach((__, index) => {
      const marker = document.createElement('button');
      marker.classList.add('carousel--marker');
      index === 0 && marker.classList.add('carousel--marker-active');
      markersWrapper.appendChild(marker);
      marker.addEventListener('click', () => emblaApi.scrollTo(index));
      markers.push(marker);
    });

    const toggleMarkersActive = () => {
      const previous = emblaApi.previousScrollSnap();
      const selected = emblaApi.selectedScrollSnap();
      markers[previous].classList.remove('carousel--marker-active');
      markers[selected].classList.add('carousel--marker-active');
    };

    emblaApi.on('select', toggleMarkersActive);
  }

  initButtons(emblaApi) {
    this.root
      .querySelector('.carousel--button-next')
      ?.addEventListener('click', () => emblaApi.scrollNext());
    this.root
      .querySelector('.carousel--button-prev')
      ?.addEventListener('click', () => emblaApi.scrollPrev());
  }
}
